/* ============================================================
   SERUM · Supplement Guide — Rendering
   Erwartet: window.SERUM_SUPPLEMENTS (unveraendertes Datenschema)
   Filter arbeiten als Toggle: kein "Alle"-Reiter, ein zweiter
   Klick auf den aktiven Chip hebt den Filter wieder auf.
   v4: Karten ohne Score-Zahlen und ohne Warnhinweis-Flag,
   Wirkstaerken als Dreiecke.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('serum-guide');
  if (!root) return;

  var DATA = (window.SERUM_SUPPLEMENTS || []).slice();
  DATA.sort(function (a, b) {
    return (b.scores[0] + b.scores[1] + b.scores[2]) - (a.scores[0] + a.scores[1] + a.scores[2]);
  });

  var TIER_ORDER = ['S', 'A', 'B', 'C', 'D', 'F'];
  var TIER_LABELS = { S: 'Elite', A: 'Stark', B: 'Solide', C: 'Situativ', D: 'Schwach', F: 'Unnötig' };
  var STATE_KEY = 'serum_guide_state';

  var out = root.querySelector('[data-sg-results]');
  var input = root.querySelector('[data-sg-search]');
  var countEl = root.querySelector('[data-sg-count]');

  // Leerer String = kein Filter aktiv = alles anzeigen
  var state = { tier: '', cat: '', search: '' };

  /* ---------- Helfer ---------- */

  function esc(s) {
    if (!s) return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function slugify(name) {
    return String(name).toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/['`´]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-{2,}/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function supplementURL(name) {
    return '/pages/supplement/' + slugify(name);
  }

  function cats(claims, name) {
    var t = claims.map(function (c) { return c[0].toLowerCase(); }).join(' ');
    var n = (name || '').toLowerCase();
    var tags = [];
    if (/kognitiv|ged(ae|ä)chtnis|konzentration|hirngesundheit|hirn/.test(t)) tags.push('Kognition');
    if (/schlaf/.test(t) || n === 'taurin') tags.push('Schlaf');
    if (/sport|muskel|ausdauer/.test(t)) tags.push('Sport');
    if (/gesundheit|immunsystem|knochen|entz(ue|ü)ndung|entgiftung/.test(t)) tags.push('Gesundheit');
    if (/stress|anspannung|emotional|wohlbefinden/.test(t)) tags.push('Stress');
    if (/herz|kreislauf|blutdruck|cholesterin/.test(t)) tags.push('Herz-Kreislauf');
    if (/testosteron|(oe|ö)strogen|schilddr(ue|ü)se|hormon/.test(t)) tags.push('Hormone');
    return tags;
  }

  function strength(level) {
    if (!level || level === '?') return '<span class="sg-str sg-str--na">unklar</span>';
    var down = level.indexOf('-') >= 0;
    var n = level.replace(/[^+-]/g, '').length;
    var tris = '';
    for (var i = 0; i < n; i++) tris += '<i class="sg-str__tri"></i>';
    return '<span class="sg-str ' + (down ? 'is-down' : 'is-up') + '" aria-label="' + (down ? 'senkend' : 'steigernd') + ', St\u00e4rke ' + n + ' von 3">' + tris + '</span>';
  }

  /* ---------- Karte ---------- */

  function card(e) {
    var solo = !e.altNames;

    var h = '<a class="sg-card" data-tier="' + e.tier + '" href="' + supplementURL(e.name) + '">';

    h += '<div class="sg-card__head' + (solo ? ' sg-card__head--center' : '') + '">' +
      '<span class="sg-badge">' + e.tier + '</span>' +
      '<span class="sg-card__id">' +
      '<span class="sg-card__name">' + esc(e.name) + '</span>' +
      (solo ? '' : '<span class="sg-card__alt">' + esc(e.altNames) + '</span>') +
      '</span>' +
      '</div>';

    h += '<div class="sg-card__claims">';
    var max = Math.min(e.claims.length, 3);
    for (var i = 0; i < max; i++) {
      h += '<div class="sg-claim"><span class="sg-claim__name">' + esc(e.claims[i][0]) + '</span>' + strength(e.claims[i][1]) + '</div>';
    }
    if (e.claims.length > 3) h += '<div class="sg-card__more">+' + (e.claims.length - 3) + ' weitere</div>';
    h += '</div>';

    if (e.format || e.dosierung) {
      h += '<dl class="sg-card__facts">';
      if (e.format) h += '<div class="sg-fact"><dt>Format</dt><dd>' + esc(e.format) + '</dd></div>';
      if (e.dosierung) h += '<div class="sg-fact"><dt>Dosierung</dt><dd>' + esc(e.dosierung) + '</dd></div>';
      h += '</dl>';
    }

    return h + '</a>';
  }

  /* ---------- Rendern ---------- */

  function render() {
    var list = DATA.filter(function (e) {
      if (state.tier && e.tier !== state.tier) return false;
      if (state.cat && cats(e.claims, e.name).indexOf(state.cat) < 0) return false;
      if (state.search) {
        var hay = (e.name + ' ' + (e.altNames || '') + ' ' + e.claims.map(function (c) { return c[0]; }).join(' ')).toLowerCase();
        if (hay.indexOf(state.search.toLowerCase()) < 0) return false;
      }
      return true;
    });

    if (!list.length) {
      out.innerHTML = '<p class="sg-empty">Keine Einträge für diese Auswahl.</p>';
      return;
    }

    var groups = {};
    list.forEach(function (e) { (groups[e.tier] || (groups[e.tier] = [])).push(e); });

    var h = '';
    TIER_ORDER.forEach(function (tier) {
      if (!groups[tier]) return;
      h += '<section class="sg-group" data-tier="' + tier + '">' +
        '<header class="sg-group__head">' +
        '<div class="sg-group__mark">' + tier + '</div>' +
        '<h2 class="sg-group__name">' + tier + '-Tier<span class="sg-group__sub">' + TIER_LABELS[tier] + '</span></h2>' +
        '<div class="sg-group__rule"></div>' +
        '</header><div class="sg-grid">';
      groups[tier].forEach(function (e) { h += card(e); });
      h += '</div></section>';
    });

    out.innerHTML = h;
  }

  /* ---------- Zustand merken ---------- */

  function save() {
    try {
      sessionStorage.setItem(STATE_KEY, JSON.stringify({
        scroll: window.scrollY || document.documentElement.scrollTop || 0,
        tier: state.tier, cat: state.cat, search: state.search
      }));
    } catch (err) { /* Private Mode: dann eben ohne */ }
  }

  function restore() {
    var raw;
    try { raw = sessionStorage.getItem(STATE_KEY); } catch (err) { return null; }
    if (!raw) return null;
    try {
      var s = JSON.parse(raw);
      state.tier = s.tier || '';
      state.cat = s.cat || '';
      state.search = s.search || '';
      return s;
    } catch (err) { return null; }
  }

  /* ---------- Filter verdrahten ---------- */

  function sync(attr, value) {
    root.querySelectorAll('[' + attr + ']').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute(attr) === value ? 'true' : 'false');
    });
  }

  function bind(attr, key) {
    root.querySelectorAll('[' + attr + ']').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute(attr);
        state[key] = (state[key] === v) ? '' : v;
        sync(attr, state[key]);
        render();
      });
    });
  }

  bind('data-sg-tier', 'tier');
  bind('data-sg-cat', 'cat');

  if (input) {
    var timer;
    input.addEventListener('input', function () {
      state.search = input.value;
      clearTimeout(timer);
      timer = setTimeout(render, 200);
    });
  }

  root.addEventListener('click', function (ev) {
    if (ev.target.closest && ev.target.closest('.sg-card')) save();
  });

  /* ---------- Start ---------- */

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  var saved = restore();
  if (countEl) countEl.textContent = DATA.length;
  if (input && state.search) input.value = state.search;
  sync('data-sg-tier', state.tier);
  sync('data-sg-cat', state.cat);
  render();

  if (saved && saved.scroll > 0) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { window.scrollTo(0, saved.scroll); });
    });
  }
  try { sessionStorage.removeItem(STATE_KEY); } catch (err) { /* egal */ }
})();
